import { Component, Input, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
})
export class TextInputComponent implements OnInit {
  @Input() maxCharCount: number = 1500;
  @Input() control!: FormControl;
  @Input() placeHolderText: string = '';
  @Input() isReadOnly: boolean = false;
  @Input() className:string = 'purpose-text-field';
  wordCount: number = 0;

  constructor() { }

  ngOnInit(): void {
    this.control.valueChanges.subscribe((typed) => {
      this.wordCount = typed ? typed.length : 0;
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['control'] && changes['control'].currentValue) {
      this.wordCount = this.control.getRawValue()?.length || 0
    }
  }
}
